import SoundOutlined from './src/sound-outlined';
export default SoundOutlined;